module.exports = __webpack_public_path__ + "img/hakuna_xmas_bg05.f87d4803.jpg";